module.exports = __webpack_public_path__ + "img/logo-inter-horizontal.4dabcf36.png";